"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAB = void 0;
var crc32 = __importStar(require("crc-32"));
var lodash_1 = require("lodash");
var getHash = lodash_1.memoize(function (s) { return crc32.str(s); });
var getFactor = function (clientId, experiment) {
    var hash = getHash("" + experiment + clientId);
    return Math.abs(hash) % 100;
};
var getGroup = function (clientId, name, experiment) {
    var factor = getFactor(clientId, name);
    return factor < experiment.A ? 'A' : 'B';
};
var getResults = function (clientId, experiments) {
    lodash_1.toPairs(experiments).forEach(function (_a) {
        var name = _a[0], conf = _a[1];
        if (lodash_1.sum(lodash_1.values(conf)) !== 100) {
            console.error("Wrong config for \"" + name + "\" experiment: sum of ranges must be equal to 100");
        }
    });
    return Object.keys(experiments).reduce(function (acc, name) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[name] = getGroup(clientId, name, experiments[name]), _a)));
    }, {});
};
var cacheKeyResolver = function (clientId, experiments) {
    return clientId + " " + Object.keys(experiments).join(',');
};
exports.getAB = lodash_1.memoize(getResults, cacheKeyResolver);
